var map = {
	"./Drhtulja.webp": 2530,
	"./Dupin.webp": 570,
	"./Fishcounting.png": 945,
	"./Golubovi.webp": 1155,
	"./Instructions_biometry_users.pdf": 5956,
	"./Instructions_custom_users.pdf": 4486,
	"./Instructions_custom_users_.pdf": 1129,
	"./Instructions_salmorapp_users.pdf": 52,
	"./Instructions_tableapp_users.pdf": 4770,
	"./Instructions_tunacounting_users.pdf": 5830,
	"./Kit.webp": 9104,
	"./Komercijalna.webp": 916,
	"./Kornjaca.webp": 8863,
	"./Rijetka.webp": 5448,
	"./Sredozemna_medvjednica.webp": 3695,
	"./Upitnik.webp": 1070,
	"./biofoulingUPUTE.pdf": 7577,
	"./biofouling_instructions.docx": 1964,
	"./biofouling_instructions.pdf": 600,
	"./check-solid.svg": 4622,
	"./customUPUTE.pdf": 6370,
	"./delete.webp": 8831,
	"./detection_instructions.pdf": 5107,
	"./download-solid.svg": 6086,
	"./email.webp": 1500,
	"./foodwaste_instructions.pdf": 5938,
	"./inspection_instructions.pdf": 9830,
	"./instructions.docx": 6525,
	"./location.webp": 2643,
	"./logo.webp": 931,
	"./morske_macke.webp": 695,
	"./morski_pas.webp": 3500,
	"./morski_stakor.webp": 9578,
	"./mortality.webp": 6549,
	"./mortality_instructions.pdf": 9173,
	"./protokol.mp4": 2775,
	"./raza.webp": 1744,
	"./razopas.webp": 9422,
	"./sklat.webp": 5711,
	"./small.webp": 291,
	"./upload.webp": 8777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8302;